// Auto-extracted from uploaded files. Kept original logic.
export default function checkUnit(symbol) {
    var n = {
        DEGREES: "degrees",
        FEET: "ft",
        METERS: "m",
        PIXELS: "pixels",
        TILE_PIXELS: "tile-pixels",
        USFEET: "us-ft",
        METERS_PER_UNIT: {}
    };
    n.METERS_PER_UNIT[n.DEGREES] = 2 * Math.PI * 6370997 / 360, n.METERS_PER_UNIT[n.FEET] = .3048, n.METERS_PER_UNIT[n.METERS] = 1, n.METERS_PER_UNIT[n.USFEET] = 1200 / 3937;
    return n.METERS_PER_UNIT[symbol];
}
